<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <payment-edit-part v-if="canAddPayment"
            :show.sync="state.dialog.show"
            title="Add Payment"
            :value="state.dialog.payment"
            v-on:input="onPaymentConfirm"
          >
          </payment-edit-part>
          <card>
            <template slot="header">
              <div class="row">
                <div class="col">
                  <h4 class="card-title">Payments</h4>
                  <p class="card-category">Donations made to your causes</p>
                </div>
                <div v-if="canAddPayment" class="col">
                  <form class="form-inline justify-content-end">
                    <button class="btn" :disabled="!canAddPayment" @click.prevent="onAddPayment">Add Payment</button>
                  </form>
                </div>
              </div> 
            </template>
            <div>
              <el-input placeholder="Filter by ..." v-model="filter.text" class="input-with-select">
                <el-select v-model="filter.by" slot="prepend" placeholder="Select">
                  <el-option label="Cause" value="cause"></el-option>
                  <el-option label="Donor" value="donor"></el-option>
                  <el-option label="Date" value="date"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>
            <payment-part
              :value="filteredData"
            ></payment-part>
            <!-- <button class="btn btn-primary">some button</button> -->
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, reactive, ref, onMounted } from '@vue/composition-api'
import graphql from '@/api/graphql'
import gql from 'graphql-tag'
import { What, Verb, can }  from '@/rights/rights.js'
import router from '@/routes/router'
import BaseRadio from '@/components/Forms/BaseRadio.vue'
import PaymentPart from '@/forms/PaymentPart.vue'
import PaymentEditPart from './PaymentEditPart.vue'

export default {
  components: {
    BaseRadio,
    PaymentPart,
    PaymentEditPart
  },
  setup(props, context) {
    const root = context.root
    const store = root.$store
    const tableData = ref([])
    const state = reactive({
      dialog: {
        show: false,
        payment: {}
      }
    })
    let profile = store.state.users.profile

    onMounted(() => {
      let graphQuery = gql`{
        paymentList {
          id,
          amount,
          currency,
          status,
          causeName,
          email,
          dtc
        }
      }`
      graphql.query(graphQuery)
        .then(json => {
          tableData.value = json.data.paymentList
        })
        .catch(gqlResponse => {
          graphql.handleError(gqlResponse, 'Error getting payment list:', store.dispatch)
        })
    })

    // Text Filter
    const filter = reactive({
      by: 'donor',
      text: ''
    })
    const filteredData = computed(() => {
      return tableData.value.filter(item => {
        let filterText = filter.text.toLowerCase()
        if (filterText == '') {
          return true
        }
        if (filter.by == 'donor') {
          return item.email.toLowerCase().includes(filterText)
        }
        else if (filter.by == 'cause') {
          return item.causeName.toLowerCase().includes(filterText)
        }
        else if (filter.by == 'date') {
          return item.dtc.includes(filterText)
        }
        return true
      })
    })
    const hasFilteredData = computed(() => {
      var result = filteredData.value.length > 0
      // console.log('hasFilteredData', filteredData.value, result)
      return result
    })

    const canAddPayment = computed(() => {
      return can(Verb.EDIT, What.PAYMENT, {})
    })

    function onAddPayment() {
      Object.assign(state.dialog.payment, {})
      console.log('add payment')
      state.dialog.show = true
    }

    function onPaymentConfirm(e) {
      console.log('onConfirm', e)
      let graphQuery = gql`mutation PaymentList($input: PaymentInput!) {
        paymentList(input: $input) {
          id,
          amount,
          currency,
          status,
          causeName,
          email,
          dtc
        }
      }`
      graphql.query(graphQuery, {
        input: e
      })
        .then(json => {
          tableData.value = json.data.paymentList
          store.dispatch('notify', { type: 'success', message: 'Payment added'})
        })
        .catch(gqlResponse => {
          graphql.handleError(gqlResponse, 'Error adding Payment:', store.dispatch)
        })
    }

    // setup return
    return {
      state,
      filter,
      filteredData,
      hasFilteredData,
      canAddPayment,
      onAddPayment,
      onPaymentConfirm
    }
  }
}
</script>
<style lang="scss">
  .el-select .el-input {
    width: 110px;
  }
</style>